document.addEventListener('DOMContentLoaded', () => {
	class FeaturesTabs {
		constructor(section) {
			if(!section) return;

			this.parent = section;

			this.init();
		}

		init() {
			this.initSelectedVariant();
			this.tabsInit();
		}

		initSelectedVariant() {
			const productOptions = document.querySelectorAll('.product-section__variant-thumbnail');
			const sections = document.querySelectorAll('.golf-features-content');

			if(!productOptions) return

			productOptions.forEach((option, index) => {
				if(option.classList.contains('is-active')) {
					this.removeClassActive(sections);
					if(sections[index]) {
						sections[index].classList.add('active');
					}
					this.tabsInit();
				}

				option.addEventListener('click', () => {
					// console.log('%c click ', 'background-color: green; color: #eee;', 'click')

					this.removeClassActive(sections);
					if(sections[index]) {
						sections[index].classList.add('active');
					}
					this.tabsInit();
				})
			})
		}

		tabsInit() {
			const tabs = document.querySelectorAll(`.${this.parent} .header .tab-items .item`);
			const bodyItems = document.querySelectorAll(`.${this.parent} .body .body-items`);
			const golFfeaturesContent = document.querySelectorAll('.golf-features-content');

			golFfeaturesContent.forEach((golf, index) => {
				if(golf.classList.contains('active')) {
					const tabsIndex = golf.querySelectorAll('.header .tab-items .item');
					const bodyItemsIndex = golf.querySelectorAll(`.body .body-items`);

					tabsIndex[0].classList.add('active');
					bodyItemsIndex[0].classList.add('active');

				}
			})


			tabs.forEach((tab, index) => {
				tab.addEventListener('click', () => {
					this.removeClassActive(tabs);
					this.removeClassActive(bodyItems);

					tab.classList.add('active');
					bodyItems[index].classList.add('active');
				})
			})
		}

		removeClassActive(elements) {
			elements.forEach(elem => elem.classList.remove('active'))
		}

		scrollToElement() {
			const targetElement = document.querySelector(`.${this.parent} .block-title .title`);
			const scrollPosition = window.innerWidth <= 1024 ? targetElement.offsetTop - 100 : targetElement.offsetTop - 150;

			window.scrollTo({
				top: scrollPosition,
				behavior: 'smooth'
			});
		}
	}

	new FeaturesTabs('golf-features');
})